<!-- toast host element for app-update messages -->
@if (updateManager) {
  <p-toast key="app-update" class="app-update" position="top-center">
    <ng-template let-message pTemplate="message">
      <div class="app-update-message-content">
        <h4 class="text-16 fw-600 color-gray-700">{{ message.summary }}</h4>
        <p-button class="h--40 w100 text-14 fw-600" (onClick)="updateManager.execUpdate()">
          {{ message.detail }}
        </p-button>
      </div>
    </ng-template>
  </p-toast>
}
